import { call, put, select, takeLatest } from "redux-saga/effects";
import { IAppContext } from "../services";
import { IJCoreService } from "../services/jcore";
import { getX10DevicesError, getX10DevicesSuccess } from "../store/x10devices/actions";
import { getX10DeviceQuery } from "../store/x10devices/selectors";
import { GET_X10_DEVICES, IX10DevicePage, IX10DeviceQuery } from "../store/x10devices/types";

/** The reducer has already merged the change into the query; this fetches the resulting page. */
export function* fetchX10Devices(jCoreService: IJCoreService) {
  const query: IX10DeviceQuery = yield select(getX10DeviceQuery);

  try {
    const page: IX10DevicePage = yield call([jCoreService, jCoreService.getX10Devices], query);

    yield put(getX10DevicesSuccess(page));
  } catch {
    yield put(getX10DevicesError());
  }
}

export default function* x10DevicesWatcher(context: IAppContext) {
  // takeLatest drops the answer of a search that was overtaken by the next keystroke.
  yield takeLatest(GET_X10_DEVICES, fetchX10Devices, context.jCoreService);
}
